import {assert} from 'Asserts';
import * as metrics from 'metrics/Metrics';
import {isValidDate} from 'util/DateUtil';
import * as logging from 'util/Logging';

interface Options {
  message: string;
  expirationDate: string;
  errorInDevAndTest: boolean;
  metricName?: string;
  sendToSentry?: boolean;
}

/**
 * Tracks violations of a putative "invariant" without halting execution in production.

  Designed for *short-term* use to gauge the impact of introducing stricter validation to existing code.

  @param condition The condition to check
  @param message Message to log when condition is False
  @param expirationDate Latest date by which this invariant should be promoted to an assertion or removed
  @param errorInDevAndTest Whether to crash on violation in test and local dev environments. Setting to true
    helps avoid regressions in new code, at the cost of obscuring any effects of the "bad" state.
  @param metricName When specified, a DD count metric will be incremented on each violation
  @param sendToSentry Whether to send an error event to Sentry on each violation. Useful when you want stack
    traces for individual cases, but beware of noise.
 */
export default function checkSoftInvariant(condition: boolean, options: Options): void {
  assert(isValidDate({textValue: options.expirationDate}), `Invalid expiration date, expected YYYY-MM-DD`);

  if (condition) {
    return;
  }

  if (options.errorInDevAndTest && (window.debug || global.__NODE_TESTING__)) {
    assert(false, options.message);
  }

  if (options.metricName) {
    metrics.count(options.metricName);
  }

  if (options.sendToSentry) {
    logging.error(options.message);
  } else {
    logging.info(options.message);
  }
}
